export default __webpack_public_path__ + "static/media/payments-placeholder.1466a691.png";